import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as EditIcon } from '../../assets/saturnia-edit.svg';

const ProductTable = ({ cabecalho, dados, refreshState, refreshList, gridClass, currentPage }) => (
	<div className={`Table${gridClass ? ` ${gridClass}` : ''}${refreshState ? ' refreshing' : ''}`}>
    
    <div className="head">
      { cabecalho.map((item) => {
        if (item === "Highlight") return <div key="Highlight" />;
        if (item === "Seen") return null;
        return <div key={item}>{item}</div>;
      }) }
      { gridClass === "Orders" && <div>Situação</div>}
      { refreshList && (
        <button className="refreshButton" onClick={refreshList}>
          <i className="fas fa-redo"></i>
        </button>
      ) }
    </div>
    <div className="body">
      { dados.map((linha, idx) => (
          <div key={idx} className="item">
            { cabecalho.map((item) => {
              if (item === "Seen" || item === "Valor") return null;
              return <span key={item}>{linha[item] || ""}</span>;
            }) }
            <Link className="absoluteEdit" to={{ pathname: linha["Ações"], state: { currentPage, url: "/" } }} >
              <EditIcon />
            </Link>
          </div>
      )) }
    </div>
	</div>
);

export default ProductTable;